<div class="d-flex align-items-center" [attr.data-id]="field.dataId">
  <checkbox-v2
    (check)="change($event)"
    [label]="props.label"
    [checked]="formControl.value"
    [disabled]="formControl.disabled"
    [id]="id + '_' + field.key"
  ></checkbox-v2>
</div>
